import ApiService from "@/core/services/api.service";

export default {
  select (query = {}) {
    return ApiService.query('geocodes', { params: query })
  }
}
